function calculateMetrics(sequence, params) {
  const { n, arms } = params;
  const armCounts = new Array(arms).fill(0);
  const blockIntegrity = new Map();
  const clusterCounts = new Map();
  const stratumCounts = new Map();

  sequence.forEach((patient) => {
    armCounts[patient.armIndex] += 1;

    if (patient.blockNumber !== null && patient.blockNumber !== undefined) {
      const key = `Block ${patient.blockNumber}`;
      const block = blockIntegrity.get(key) || new Array(arms).fill(0);
      block[patient.armIndex] += 1;
      blockIntegrity.set(key, block);
    }

    if (patient.cluster) {
      const cluster = clusterCounts.get(patient.cluster) || new Array(arms).fill(0);
      cluster[patient.armIndex] += 1;
      clusterCounts.set(patient.cluster, cluster);
    }

    if (patient.stratum) {
      const stratum = stratumCounts.get(patient.stratum) || new Array(arms).fill(0);
      stratum[patient.armIndex] += 1;
      stratumCounts.set(patient.stratum, stratum);
    }
  });

  const maxCount = Math.max(...armCounts);
  const minCount = Math.min(...armCounts);
  const imbalance = maxCount - minCount;
  const imbalancePercent = Number(((imbalance / n) * 100).toFixed(2));
  const warnings = [...(params.methodWarnings || [])];

  if (imbalancePercent > 15) {
    warnings.push('Overall imbalance is above 15%; review technique choice for small studies.');
  }

  const blocks = Array.from(blockIntegrity.entries()).map(([block, counts]) => {
    const blockMax = Math.max(...counts);
    const blockMin = Math.min(...counts);

    return {
      block,
      counts,
      balanced: blockMax === blockMin
    };
  });

  const clusters = Array.from(clusterCounts.entries()).map(([cluster, counts]) => ({
    cluster,
    counts,
    imbalance: Math.max(...counts) - Math.min(...counts)
  }));

  const strata = Array.from(stratumCounts.entries()).map(([stratum, counts]) => ({
    stratum,
    counts,
    imbalance: Math.max(...counts) - Math.min(...counts)
  }));

  if (blocks.some((block) => !block.balanced)) {
    warnings.push('At least one incomplete block is not perfectly balanced.');
  }

  return {
    armCounts,
    imbalance,
    imbalancePercent,
    blockIntegrity: blocks,
    clusterBalance: clusters,
    stratumBalance: strata,
    validation: warnings.length === 0 ? 'PASS' : 'WARN',
    warnings
  };
}

module.exports = {
  calculateMetrics
};
